import React, { useCallback } from 'react';
import classNames from 'classnames';
import { NavLink, useLocation } from 'react-router-dom';
import { NEW_WINDOW_PROPS } from 'data/global';
import { IconProp } from 'models/Icon';
import { NAVIGATION_VARIANTS, NavigationVariants } from 'models/Navigation';
import Counter from 'components/Counter';
import { NewTag } from 'router/subrouters/DataRoom/components/NewTag';

import './Subnav.styles.scss';

export type SubnavLinks = {
  to: string;
  id?: string;
  className?: string;
  label?: string;
  openInNewTab?: boolean;
  count?: number;
  isNew?: boolean;
  Icon?: IconProp;
};

type SubnavProps = {
  className?: string;
  variant?: NavigationVariants;
  links: SubnavLinks[];
  routerHomeLink?: SubnavLinks;
};

const Subnav: React.FC<SubnavProps> = (props) => {
  const {
    className,
    links,
    routerHomeLink,
    variant = NAVIGATION_VARIANTS.SECONDARY,
  } = props;

  const classes = classNames('subnav', `subnav--${variant}`, className);

  const { pathname } = useLocation();

  const renderIcon = useCallback((Icon: IconProp) => Icon && <Icon />, []);

  return (
    <nav className={classes}>
      <ul>
        {routerHomeLink && (
          <li>
            <NavLink
              to={routerHomeLink.to}
              className={({ isActive }) =>
                classNames(routerHomeLink.className, {
                  active: isActive && pathname === routerHomeLink.to,
                })
              }
              {...(routerHomeLink.openInNewTab ? NEW_WINDOW_PROPS : {})}
            >
              {renderIcon(routerHomeLink.Icon)}
              {routerHomeLink.label}

              <Counter count={routerHomeLink.count} isPositionAbsolute />
            </NavLink>
          </li>
        )}
        {links.map(
          ({
            to,
            label,
            openInNewTab,
            id,
            className,
            isNew,
            count = 0,
            Icon,
          }) => (
            <li key={to}>
              <NavLink
                to={to}
                id={id}
                className={({ isActive }) =>
                  classNames(className, { active: isActive })
                }
                {...(openInNewTab ? NEW_WINDOW_PROPS : {})}
              >
                {renderIcon(Icon)}
                {label}

                {isNew && <NewTag variant={'blue'} time={new Date()} />}

                <Counter count={count} isPositionAbsolute />
              </NavLink>
            </li>
          ),
        )}
      </ul>
    </nav>
  );
};

export default Subnav;
